/* eslint-disable max-len */
// Dependencies
import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'

import Helpers from '../Helpers.js'
import {storePayload} from '../actions/storePayload.js'
import {submitUserFeedback} from '../actions/submitUserFeedback.js'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesModuleLogList from '../styles/ModuleLogList.module.css'
const tableEntryStyles = {
  error: {
    border: '1px solid #FF4C4D',
    background: '#4D1509',
  },
  warning: {
    border: '1px solid #FA0',
    background: 'rgba(178, 89, 0, 0.50)',
  },
  0: {},
}

// Components
import {Icon, Modal2, Table, TableEntry, Animation} from '@lazarusai/forms-ui-components'
// import {Modal2, Table, TableEntry} from '@lazarusai/forms-ui-components'
import TaskQueue from './TaskQueue'
import TaskView from './TaskView'
// import AlertButton from './AlertButton'
import LogTable from './LogTable'
import CodeCompare from './CodeCompare'
import UserFeedback from './UserFeedback.js'

function ModuleLogList({
  moduleKey,
  ...props
}) {
  const [formattedQueueList, setFormattedQueueList] = useState([])
  const [isModuleModalShowing, setIsModuleModalShowing] = useState(false)
  const [moduleName, setModuleName] = useState('')
  const [moduleStatus, setModuleStatus] = useState('')
  const [userFeedbackQuestion, setUserFeedbackQuestion] = useState('')

  const selectedTask = props?.modules?.[moduleKey]?.tasks?.[props.taskId]

  function selectMostRecentTask(module) {
    if (module) {
      const mostRecentTask = Object.keys(module?.tasks)
          .sort((aTaskKey, bTaskKey) => {
            const aVal = module?.tasks?.[aTaskKey]?.last_update || Number.MIN_SAFE_INTEGER
            const bVal = module?.tasks?.[bTaskKey]?.last_update || Number.MIN_SAFE_INTEGER
            return bVal - aVal
          })?.[0] || null
      props.storePayload({
        selectedModuleKey: moduleKey,
        taskId: mostRecentTask,
      })
    }
  }

  useEffect(() => {
    const module = props.modules?.[moduleKey]
    const tasks = Helpers.removeDuplicateTasks(module?.tasks)
    if (props.isCodeModule) {
      setFormattedQueueList(Object.keys(tasks)?.map((taskKey, sIndex) => {
        const task = tasks[taskKey]
        const isFakeBroken = moduleKey === 'm&a' && props.isExpectingCodeBreak
        const taskStatusRunning = !isFakeBroken && (Object.keys(task?.logs || {})?.length < 2)
        const taskName = task?.name
        const taskTimestamp = task?.last_update
        return (
          <TableEntry
            key={`${sIndex}-log-row`}
            // style={tableEntryStyles?.[taskStatus] || {}}
            content={[
              <div
                className={
                  `${stylesModuleLogList['mll-queue-title']} ${taskStatusRunning ? stylesModuleLogList['loading-log'] : ''} notranslate`
                }
                key={`log-status-${sIndex}`}
              >
                <div className='notranslate' translate='no'>
                  {taskStatusRunning && false ?
                    <Animation
                      key={`log-status-icon-${taskStatusRunning ? 'done': 'active'}-${sIndex}`}
                      animationState={'generating'}
                      stopAnimation={taskStatusRunning}
                      height={'24px'}
                      width={'24px'}
                    /> :
                    <Icon
                      key={`log-status-icon-${taskStatusRunning ? 'run': 'done'}-${sIndex}`}
                      icon={taskStatusRunning ? 'checkmark-circle-2-outline' : 'checkmark-circle-2'}
                    />
                  }
                </div>
                {Helpers.truncateString(taskName.replaceAll('break', 'repair'), 18)}
              </div>,
            taskTimestamp ?
              `${Helpers.timeStampToDate(parseInt(taskTimestamp))} ${Helpers.timeStampToTime(parseInt(taskTimestamp))}` :
              '',
            ]}
          />
        )
      }))
    } else {
      const taskSteps = Object.keys(tasks)
          ?.sort((aKey, bKey) => {
            return (tasks?.[bKey]?.last_update || Number.MIN_SAFE_INTEGER) - (tasks?.[aKey]?.last_update || Number.MIN_SAFE_INTEGER)
          })
          ?.map((taskKey, tIndex) => {
            const task = tasks?.[taskKey]
            const taskName = task?.name
            const logsObj = task?.logs
            if (logsObj) {
              const tempLogs = Object.keys(logsObj).sort((aKey, bKey) => (logsObj?.[bKey]?.time || Number.MAX_SAFE_INTEGER) - (logsObj?.[aKey]?.time || Number.MAX_SAFE_INTEGER))
              const sortedLogs = {}
              for (let lIndex = 0; lIndex < tempLogs.length; lIndex++) {
                const log = logsObj[tempLogs[lIndex]]
                const logType = log?.type || 'action'
                if (logType === 'action') {
                  const numCalls = log?.tool_calls?.length || -1
                  for (let tIndex = 0; tIndex < numCalls; tIndex++) {
                    const callId = log?.tool_calls?.[tIndex]?.id
                    if (!sortedLogs?.[callId]) {
                      sortedLogs[callId] = {}
                    }
                    const newAction = structuredClone(log)
                    newAction.tool_calls = [log?.tool_calls?.[tIndex]]
                    sortedLogs[callId]['action'] = newAction
                    sortedLogs[callId]['task-status'] = task?.status
                  }
                } else if (logType === 'action_output') {
                  const callId = log?.tool_call_id
                  if (!sortedLogs?.[callId]) {
                    sortedLogs[callId] = {}
                  }
                  sortedLogs[callId]['action-output'] = structuredClone(log)
                } else if (logType === 'summary_output') {
                  sortedLogs['summary_output'] = structuredClone(log)
                  sortedLogs['summary_output']['name'] = taskName
                } else if (logType === 'final_output' || logType === 'final-output') { // final output
                  sortedLogs['final-output'] = structuredClone(log)
                  sortedLogs['final-output']['name'] = taskName
                }
              }

              const logsNoSummary = {}
              let summaryKey = null
              Object.keys(sortedLogs).forEach((key) => {
                if (sortedLogs[key].type === 'summary_output') {
                  summaryKey = key
                } else {
                  logsNoSummary[key] = sortedLogs[key]
                }
              })

              const sortedKeys = Object.keys(logsNoSummary).sort((aKey, bKey) => (sortedLogs?.[aKey]?.['action-output']?.time || Number.MAX_SAFE_INTEGER) - (sortedLogs?.[bKey]?.['action-output']?.time || Number.MAX_SAFE_INTEGER))
              if (summaryKey) {
                sortedKeys.push(summaryKey)
              }

              return sortedKeys.reverse().map((key) => sortedLogs[key])
            }
          })
      const stepLogs = taskSteps.flat(Infinity)
      setFormattedQueueList(stepLogs?.map((step, sIndex) => {
        const taskStatusRunning = step?.['action'] && !step?.['action-output'] && !(step?.['task-status']?.toLowerCase() === 'error')
        const taskStatusError = step?.['action'] && !step?.['action-output'] && (step?.['task-status']?.toLowerCase() === 'error')
        const taskName = step?.['action']?.['tool_calls']?.[0]?.['function']?.['name'] ?
          Helpers.snakeCaseToDisplay(step?.['action']?.['tool_calls']?.[0]?.['function']?.['name']) :
            step?.name ?
              `${step?.type ? Helpers.snakeCaseToDisplay(step?.type) : ''} - ${step?.name || ''}` :
              ''
        const taskTimestamp = step?.['time'] || step?.['action-output']?.time || step?.['action']?.time
        if (taskName) {
          return (
            <TableEntry
              key={`${sIndex}-log-row`}
              style={tableEntryStyles?.[taskStatusError ? 'error' : ''] || {}}
              content={[
                <div
                  className={
                    `${stylesModuleLogList['mll-queue-title']} ${taskStatusRunning ? stylesModuleLogList['loading-log'] : ''}`
                  }
                  key={`log-status-${sIndex}`}
                >
                  <>
                    {taskStatusRunning && false ?
                    <Animation
                      key={`log-status-icon-${taskStatusRunning ? 'done': 'active'}-${sIndex}`}
                      animationState={'generating'}
                      stopAnimation={taskStatusRunning}
                      height={'24px'}
                      width={'24px'}
                    /> :
                    <Icon
                      key={`log-status-icon-${taskStatusError ? 'error': 'done'}-${sIndex}`}
                      icon={taskStatusRunning ? 'checkmark-circle-2-outline' : taskStatusError ? 'close-square' : 'checkmark-circle-2'}
                    />
                    }
                  </>
                  {
                    taskName && taskName.length > 0 ?
                    Helpers.truncateString(taskName, 18) : 'Init'
                  }
                </div>,
              taskTimestamp ?
                `${Helpers.timeStampToDate(parseInt(taskTimestamp))} ${Helpers.timeStampToTime(parseInt(taskTimestamp))}` :
                '',
              ]}
            />
          )
        }
      }))
    }
  }, [props.modules, moduleKey])

  useEffect(() => {
    const module = props.modules?.[moduleKey]
    if (module && props.isCodeModule && props.isExpectingCodeBreak) {
      // Some check to see if should pop up modal
      // Get Task Key
      const hasFixCompleted = module?.status?.toLowerCase() === 'stand-by' && moduleStatus?.toLowerCase() !== 'stand-by' && moduleStatus?.length > 0
      if (hasFixCompleted) {
        props.storePayload({
          isExpectingCodeBreak: false,
        })
        selectMostRecentTask(module)
      }
    }
    if (module) {
      setModuleName(module?.name || moduleKey)
      setModuleStatus(module?.status || 'running')
      // if (module?.tasks) {
      //   const tasks = Helpers.removeDuplicateTasks(module?.tasks)
      //   // const tasks = module?.tasks
      //   setFormattedQueueList(Object.keys(tasks)
      //       ?.sort((aKey, bKey) => {
      //         return (tasks?.[bKey]?.last_update || Number.MIN_SAFE_INTEGER) - (tasks?.[aKey]?.last_update || Number.MIN_SAFE_INTEGER)
      //       })
      //       ?.map((taskKey, tIndex) => {
      //         const task = tasks?.[taskKey]
      //         const taskName = task?.name || `Task ${tIndex+1}`
      //         const taskStatus = task?.status
      //         const taskStatusRunning = taskStatus === 'running'
      //         const taskTimestamp = task?.last_update
      //         return (
      //           <TableEntry
      //             key={`${tIndex}-log-row`}
      //             style={tableEntryStyles?.[taskStatus] || {}}
      //             content={[
      //               <div
      //                 className={stylesModuleLogList['mll-queue-title']}
      //                 key={`log-status-${tIndex}`}
      //               >
      //                 <Icon
      //                   key={`log-status-icon-${taskStatusRunning ? 'done': 'active'}-${tIndex}`}
      //                   icon={taskStatusRunning ? 'loader-outline' : 'checkmark-circle-2'}
      //                 />
      //                 {Helpers.truncateString(taskName, 18)}
      //               </div>,
      //               taskTimestamp ?
      //                 `${Helpers.timeStampToDate(parseInt(taskTimestamp))} ${Helpers.timeStampToTime(parseInt(taskTimestamp))}` :
      //                 '',
      //             ]}
      //           />
      //         )
      //       }))
      // }
      if (module?.tasks?.[props.taskId]?.status?.toLowerCase() === 'input') {
        // Check if a task needs feedback (maybe separate useEffect)
        const task = module?.tasks?.[props.taskId]
        const completedCalls = Object.keys(task?.logs || {})
            .filter((logKey, lIndex) => {
              return task?.logs?.[logKey]?.type === 'action_output'
            })
            .map((logKey, lIndex) => {
              return task?.logs?.[logKey]?.tool_call_id
            })
        const inputLogs = Object.keys(task?.logs || {}).map((logKey, lIndex) => {
          const log = task?.logs?.[logKey]
          const obj = log?.tool_calls?.[0]?.function
          const callId = log?.tool_calls?.[0]?.id
          if (completedCalls.includes(callId)) {
            return null
          }
          if (obj) {
            obj['time'] = log?.time
          }
          return obj
        }).filter((val) => (val && (val?.name === 'user_input')))
        const inputLog = inputLogs?.sort((aFunc, bFunc) => {
          return (bFunc?.time || Number.MIN_SAFE_INTEGER) - (aFunc?.time || Number.MIN_SAFE_INTEGER)
        })?.[0]
        const userQuestion = Helpers.isStringJSON(inputLog?.arguments) ? JSON.parse(inputLog?.arguments)?.question : inputLog?.arguments
        setUserFeedbackQuestion(userQuestion)
      }
    }
  }, [props.modules, moduleKey])

  useEffect(() => {
    if (moduleKey && props.selectedModuleKey && (moduleKey === props.selectedModuleKey)) {
      setIsModuleModalShowing(true)
      if (props.selectedModuleKey === 'code') {
        selectMostRecentTask(props.modules?.[props.selectedModuleKey])
      }
    } else {
      setIsModuleModalShowing(false)
    }
  }, [moduleKey, props.selectedModuleKey])

  function onDismissModal() {
    setIsModuleModalShowing(false)
    props.storePayload({
      taskId: null,
      selectedModuleKey: null,
    })
  }

  const mllClassNames = {
    ['error']: stylesModuleLogList['error-card'],
    ['warning']: stylesModuleLogList['warning-card'],
    ['input']: stylesModuleLogList['warning-card'],
    ['thinking']: stylesModuleLogList['thinking-card'],
    ['running']: stylesModuleLogList['running-card'],
    ['code repair']: stylesModuleLogList['running-card'],
    ['code fixing']: stylesModuleLogList['running-card'],
    ['code break']: stylesModuleLogList['running-card'],
  }

  return (
    <>
      <div
        className={`${stylesModuleLogList['module-log-list-card']} ${mllClassNames[moduleStatus?.toLowerCase()] || ''}`}
        onClick={() => {
          props.storePayload({
            selectedModuleKey: moduleKey,
          })
        }}
      >
        <div
          className={stylesModuleLogList['mll-card-title']}
        >
          {moduleName}
        </div>
        <div
          className={`${stylesModuleLogList['mll-card-title-status']}`}
        >
          <div className={stylesModuleLogList['mll-card-title-status-icon']}></div>
          <div
            className={stylesModuleLogList['mll-card-title-status-text']}
          >
            {/* {props?.error || props?.warning || 'ACTIVE'} */}
            {moduleStatus.toLowerCase().replaceAll('break', 'repair').toUpperCase()}
          </div>
        </div>
        <Table
          showCount={false}
          columnTitles={props.isCodeModule ? [
            <span
              key={'header-log'}
            >
              Log
            </span>,
            <span
              key={'header-time'}
            >
              Time
            </span>,
          ] : [
            <span
              key={'header-queue'}
            >
              Queue
            </span>,
            <span
              key={'header-status'}
            >
              Last Update
            </span>,
          ]}
          theme={props.theme}
          entries={formattedQueueList}
          className={`${stylesModuleLogList['mll-table']} ${stylesModuleLogList['mll-table-code']}`}
        />
      </div>
      <div
        style={{
          position: 'fixed',
          zIndex: '3',
        }}
      >
        <Modal2
          isVisible={isModuleModalShowing}
          theme={props.theme}
          height={'90'}
          width={'90'}
          style={{
            position: 'fixed',
            height: '90vh',
            width: '90vw',
            minWidth: '500px',
            minHeight: '300px',
          }}
          showConfirm={false}
          showClose={true}
          onDismiss={onDismissModal}
          title={moduleName}
          hasLine={false}
          className={stylesModuleLogList['mll-modal']}
          contentContainerStyle={{overflowY: 'hidden'}}
        >
          {props.taskId && userFeedbackQuestion?.length > 0 && <UserFeedback
            question={userFeedbackQuestion}
            onAnswerSubmit={(answer) => {
              props.submitUserFeedback(moduleKey, props.taskId, answer)
              setUserFeedbackQuestion(null)
            }}
          />}
          <div
            className={`${stylesModuleLogList['mll-modal-status-row']} ${moduleStatus === 'error' ? stylesModuleLogList['error-modal']: moduleStatus === 'warning' ? stylesModuleLogList['warning-modal']: (moduleStatus === 'running' || moduleStatus?.toLowerCase()?.includes('code')) ? stylesModuleLogList['running-modal']: (moduleStatus.toLowerCase() === 'thinking') ? stylesModuleLogList['thinking-modal']: ''}`}
          >
            <div
              className={`${stylesModuleLogList['mll-card-title-status']}`}
            >
              <div className={stylesModuleLogList['mll-card-title-status-icon']}></div>
              <div
                className={stylesModuleLogList['mll-card-title-status-text']}
              >
                {/* {props?.error || props?.warning || 'ACTIVE'} */}
                {moduleStatus.toLowerCase().replaceAll('break', 'repair').toUpperCase()}
              </div>
            </div>
            {/* <AlertButton
            /> */}
          </div>
          {props.isCodeModule ?
          <div
            className={stylesModuleLogList['code-modal-wrapper']}
          >
            <LogTable
              singleVal={true}
              logs={Object.keys(props.modules?.[moduleKey]?.tasks || {})
                  .sort((aTaskKey, bTaskKey) => {
                    const aVal = props.modules?.[moduleKey]?.tasks?.[aTaskKey]?.last_update || Number.MIN_SAFE_INTEGER
                    const bVal = props.modules?.[moduleKey]?.tasks?.[bTaskKey]?.last_update || Number.MIN_SAFE_INTEGER
                    return bVal - aVal
                  })
                  .map((taskKey) => {
                    return {
                      action: props.modules?.[moduleKey]?.tasks?.[taskKey]?.name || '',
                      timestamp: props.modules?.[moduleKey]?.tasks?.[taskKey]?.last_update ?
                        parseInt(props.modules?.[moduleKey]?.tasks?.[taskKey]?.last_update) :
                        0,
                      id: taskKey,
                    }
                  })
              }
              selectedId={
                props.taskId
              }
              selectedIndex={
                props.modules?.[moduleKey]?.tasks?.length ?
                  props.modules?.[moduleKey]?.tasks?.indexOf(props.taskId) :
                  0
              }
              onClick={(taskKey) => {
                const task = props.modules?.[moduleKey]?.tasks?.[taskKey]
                if (task) {
                  props.storePayload({
                    taskId: taskKey,
                  })
                }
              }}
            />
            <CodeCompare
              leftSide={{
                title: 'Error Code',
                description: selectedTask?.description,
                infoIcon: 'alert-triangle',
                code: selectedTask?.sources?.[0]?.data,
                codeLanguage: 'python',
              }}
              rightSide={{
                title: 'Fixed Code',
                description: selectedTask?.solution?.content || selectedTask?.solution || '',
                infoIcon: 'checkmark-circle-2',
                code: selectedTask?.sources?.[1]?.data,
                codeLanguage: 'python',
              }}
            />
          </div> :
          props.taskId ?
            <TaskView
              moduleKey={moduleKey}
            />:
            <TaskQueue
              moduleKey={moduleKey}
            />
          }
        </Modal2>
      </div>
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
  taskId: state.userReducer.taskId,
  modules: state.userReducer.modules,
  selectedModuleKey: state.userReducer.selectedModuleKey,
  taskId: state.userReducer.taskId,
  isExpectingCodeBreak: state.userReducer.isExpectingCodeBreak,
})

export default connect(
    mapStateToProps,
    {storePayload, submitUserFeedback},
)(ModuleLogList)
